import { requestV2 } from "@/config/serve.js";

// api-应用白名单（市场模块）
// 查询应用白名单列表
export function queryAppMarketWhiteList(data) {
  return requestV2("post", "/appMarketWhite/list", data);
}
// 批量新增应用白名单（按所选项目号生成 items 批量写入，重复校验由后端完成）
export function batchSaveAppMarketWhite(data) {
  return requestV2("post", "/appMarketWhite/batchSave", data);
}
// 编辑（行内编辑保存单条记录）
export function updateAppMarketWhite(data) {
  return requestV2("post", "/appMarketWhite/update", data);
}
// 上线
export function onlineAppMarketWhite(data) {
  return requestV2("post", "/appMarketWhite/online", data);
}
// 下线
export function offlineAppMarketWhite(data) {
  return requestV2("post", "/appMarketWhite/offline", data);
}
